import React, { useEffect, useRef, useState } from 'react';

import { Body2 } from '@cian/ui-kit';
import { OfferCard } from '../../components/OfferCard';
import { IOffer } from '../../types';
import { ActionsContainer } from '../ActionsContainer';

import { useScrollStopOnView } from '../../../common/hooks/useScrollStopOnView/useScrollStopOnView';
import { ETestIds } from '../../constants';
import { IOfferForAnalytic } from '../../utils/tracking/types';
import { useTracking } from '../../utils/tracking/useTracking';
import * as styles from './styles.css';

export interface IDesktopListingContainerProps {
  onCardClick: (offer: IOffer) => () => void;
  offerList: IOffer[];
  offerListForAnalytics: IOfferForAnalytic[];
}

export const DesktopListingContainer: React.FC<IDesktopListingContainerProps> = ({
  onCardClick,
  offerList,
  offerListForAnalytics,
}) => {
  const { trackShowOffers } = useTracking();
  const [isTracked, setIsTracked] = useState(false);
  const listingRef = useRef<HTMLDivElement | null>(null);

  useScrollStopOnView(listingRef, {
    onStop: () => {
      trackShowOffers(offerListForAnalytics);
      setIsTracked(true);
    },
    threshold: 0.5,
  });

  useEffect(() => {
    if (isTracked) {
      trackShowOffers([]);
    }

    return;
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={listingRef} data-testid={ETestIds.DesktopListing}>
      <div className={styles['heading']}>
        <div className={styles['heading__wrapper']}>
          <Body2 color={'text-secondary-default'}>Ставка</Body2>
          <Body2 color={'text-secondary-default'}>Платёж</Body2>
        </div>
      </div>
      <div>
        {offerList.map((offer, index) => {
          return (
            <div key={index} className={styles['listing__card']}>
              <OfferCard offer={offer} onClick={onCardClick(offer)} />
            </div>
          );
        })}
      </div>
      <ActionsContainer />
    </div>
  );
};
